import { getDate } from "../../../utils/date/date";
import { DateHelper } from "../DateHelper/DateHelper";

export class DRE {
    static RECEITA_BRUTA = "rbc33bB8KFBNznXsX";
    static RECEITA_LIQUIDA = "ABk7k5w7AARjAcTsi";
    constructor({
        Serie,
        CalculatingMachine,
        Point,
        CalculatingMachineV2Gateway
    } = {}) {
        this.Serie = Serie;
        this.Point = Point;
        this.CalculatingMachine = CalculatingMachine;
        this.CalculatingMachineV2Gateway = CalculatingMachineV2Gateway;
    }

    getPoint({ points, time, serie, opt, scenarioId = "ORIGINAL" }) {
        const point = points.find((point) => {
            return (
                point.s === serie._id &&
                point.t.getTime() === getDate(time).getTime() &&
                point.sc === scenarioId
            );
        });

        return this.CalculatingMachine.valueGet(serie, point, null, opt);
    }

    getPointGoal({ points, serie, opt }) {
        const point = points.find((point) => {
            return point.s === serie._id;
        });

        return this.CalculatingMachine.valueGet(serie, point, null, opt);
    }

    getSeriesAndPointsReportFin({
        companyId,
        period,
        source,
        scenarioId = "ORIGINAL",
        options = {},
        verticalReference = false
    }) {
        let series = [];
        series = this.Serie.get(
            {
                companyId: "EMPRESA_NUCONT",
                sources: "fin"
            },
            {
                $referenceAssociated: true,
                sort: { classifier: 1 }
            },
            companyId
        );

        if (verticalReference && source === "fin") {
            const revenues = {
                "RECEITA LIQUIDA": "Receita Líquida",
                "RECEITAS OPERACIONAIS": "Receitas Operacionais"
            };
            const verticalReferenceSerie = this.Serie.findOneCollection({
                name: revenues[verticalReference]
            });
            series.push(verticalReferenceSerie);
        }

        this.CalculatingMachine.setSource(source);

        const pointsResult = this.CalculatingMachine.result({
            companyId: companyId,
            serieIds: series.map((serie) => serie._id),
            scenario: scenarioId,
            period: period,
            options: {
                recalculate: true,
                visualizationAccumulated: false,
                ...options
            }
        });

        return { series, points: pointsResult };
    }

    getSeriesAndPoints({
        companyId,
        period,
        source,
        scenarioId = "ORIGINAL",
        options = {}
    }) {
        let series = [];

        if (source == "fin") {
            series = this.Serie.get(
                {
                    companyId,
                    sources: "fin"
                },
                {
                    $referenceAssociated: true,
                    sort: { classifier: 1 }
                },
                companyId
            );
        } else {
            series = this.Serie.get(
                {
                    sources: source,
                    companyId: "EMPRESA_NUCONT",
                    "metadata.origin": "dre"
                },
                {
                    $referenceAssociated: true,
                    sort: { classifier: 1 }
                },
                companyId
            );
        }

        this.CalculatingMachine.setSource(source);

        const pointsResult = this.CalculatingMachine.result({
            companyId: companyId,
            serieIds: series.map((serie) => serie._id),
            scenario: scenarioId,
            period: period,
            options: {
                recalculate: true,
                visualizationAccumulated: false,
                ...options
            }
        });

        return { series, points: pointsResult };
    }

    /**
     * @public
     * Get the year
     * @param {DateString} actualDate Actual date
     * @returns {Number} Year
     */
    onYearGet = (actualDate) => {
        if (actualDate) {
            const t = new DateHelper(actualDate)
                .startOf("month")
                .month(0)
                .format("YYYY");

            return parseInt(t);
        } else {
            return new Date().getUTCFullYear();
        }
    };

    async populate({ companyId, years, source, isGroup, companyIds }) {
        if (source == "fin") {
            return await this.Serie.populateDepartament({
                companyId,
                source,
                origin: "dre"
            });
        } else {
            return await Promise.all([
                this.Serie.getByCompanyDemand({
                    companyId: companyIds ? companyIds : companyId,
                    seriesIds: [
                        "9992k1z7AARjAcTsi",
                        "ABk7k5w7AARjAcTsi",
                        "B5uExTX6KGf2KFBWQ",
                        "C6uExTX6KGf2KFBWQ",
                        "D7uExTX6KGf2KFBWQ",
                        "E8uExTX6KGf2KFBWQ",
                        "F9uExTX6KGf2KFBWQ",
                        "G1uExTX6KGf2KFBWQ",
                        "GLk2k1z7AARjAcTsi",
                        "H2uExTX6KGf2KFBWQ",
                        "I3uExTX6KGf2KFBWQ",
                        "JDE2eqh9F4mwoeBJXh",
                        "PQk2k1z7AARjAcTsi",
                        "PiR2k1z7AVEjAcAsi",
                        "ZLk2k1z7AARjAcTsi",
                        "miuExTX6KGf2KFBWQ",
                        "rbc33bB8KFBNznXsX",
                        "Qfmph573HMafAhrB3"
                    ]
                })
            ]);
        }
    }
    async populateCalc({
        scenarioId,
        periodName,
        company,
        source,
        years,
        currentDate,
        currentComparation,
        allYearsAvailable,
        projection,
        budget,
        allMonthsByYear,
        seriesIds
    }) {
        await this.CalculatingMachineV2Gateway.calculateSeries({
            companyData: company,
            source,
            scenarioId,
            analysisPeriod: periodName,
            years,
            currentDate,
            currentComparation,
            allYearsAvailable,
            projection,
            budget,
            allMonthsByYear,
            seriesIds
        });
    }
}
